import { api } from './client';

// Search API
export interface SearchResult {
  type: 'user' | 'task' | 'project';
  id: string;
  title: string;
  subtitle?: string;
  avatar_url?: string;
}

export interface SearchResults {
  users: import('../types').User[];
  tasks: import('../types').Task[];
  projects: import('../types').Project[];
}

export const searchApi = {
  search: (params: { q: string; type?: 'users' | 'tasks' | 'projects'; limit?: number }) =>
    api.get<{
      query: string;
      results: SearchResults;
      counts: { users: number; tasks: number; projects: number; total: number };
    }>('/search', params),

  quickSearch: (q: string) => api.get<{ results: SearchResult[] }>('/search/quick', { q }),
};
